export const convertTypeFromAction = (actionCreator: any) => actionCreator.toString()
